import api from './api';
import axios from 'axios';

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const getUserAgent = () => navigator.userAgent;

const getIpAddress = async () => {
  const response = await axios.get('https://api.ipify.org?format=json');
  return response.data.ip;
};

export const signin = async (email, password) => {
  try {
    const ipAddress = await getIpAddress();
    const userAgent = getUserAgent();

    const response = await api.post('/auth/signin', {
      email,
      password,
      userTimeZone,
      ipAddress,
      userAgent
    });

    return response.data;
  } catch (error) {
    console.error(
      'Error en el inicio de sesión:',
      error.response?.data || error.message
    );
    throw error.response?.data || error;
  }
};

// Solicitar restablecimiento de contraseña
export const requestPasswordReset = async email => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/requestPasswordReset`,
    { email }
  );
  return response.data;
};

// Restablecer la contraseña
export const resetPassword = async (token, newPassword) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/auth/resetPassword`,
    { token, newPassword }
  );
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token'); // Elimina el token
  window.location.href = '/authentication/card/logout'; // Redirige al usuario a la página de inicio de sesión
};
